import React, { useState } from 'react';
import { Table, Dropdown } from 'components';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Card } from 'components';
import ButtonBTN from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import * as FileServer from 'file-saver';
import * as XLSX from 'xlsx';
import { renderStatusColorClass } from 'services/helpers';
import ExpandedDocumentsTable from './ExpandedDocumentsTable';

const Body = ({ _this }) => {
  const exportReport = () => {
    const extractedDataArray = _this.tableData.map((dataObject) => ({
      'No. Of Documents': dataObject.documents_count,
      'Customer ID': dataObject.customer_id,
      'Customer Name': dataObject.customer_name,
      Location: dataObject.location_name,
      Franchise: dataObject.franchise_name,
      Status: dataObject.status,
      'Created On': moment(dataObject.created_on).format('YYYY-MM-DD')
    }));

    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const ws = XLSX.utils.json_to_sheet(extractedDataArray);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'data');
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileServer.saveAs(data, 'Missing Authorization Form Patients' + fileExtension);
  };

  const columns = [
    {
      expander: true,
      Header: '',
      width: 35,
      Expander: ({ isExpanded }) => <div>{isExpanded ? '▼' : '▶'}</div>
    },
    {
      accessor: 'documents_count',
      Header: 'No. Of Documents',
      Cell: (row) => <div>{row.original.documents_count}</div>
    },

    {
      accessor: 'customer_id',
      Header: 'Customer ID',
      Cell: (row) => (
        <div className="flex gap-2 px-2 justify-center items-center">
          <Link
            to={`/customer-info/${row.original.customer_mongo_id}`}
            className="text-blue-500 font-medium"
          >
            {row.original.customer_id}
          </Link>
        </div>
      )
    },
    {
      accessor: 'customer_name',
      Header: 'Customer Name',
      Cell: (row) => <div>{row.original.customer_name}</div>
    },
    {
      accessor: 'location_name',
      Header: 'Location',
      Cell: (row) => <div>{row.original.location_name}</div>
    },
    {
      accessor: 'franchise_name',
      Header: 'Franchise',
      Cell: (row) => <div>{row.original.franchise_name}</div>
    },
    {
      accessor: 'status',
      Header: 'Status',
      Cell: (row) => (
        <div
          className={`${renderStatusColorClass(
            row.original?.status === 'Active'
              ? 'Active'
              : row.original?.status === 'Deleted'
              ? 'Cancelled'
              : 'OnHold'
          )}`}
        >
          {row.original.status}
        </div>
      )
    },
    {
      accessor: 'created_on',
      Header: 'Created On',
      Cell: (row) => <div>{moment(row.original.created_on).format('YYYY-MM-DD')}</div>
    }
  ];

  const optionsList =
    _this.filterType?.value === 'franchise'
      ? _this.franchiseList
      : _this.filterType?.value === 'location'
      ? _this.locationList
      : [];

  return (
    <div>
      <Card className="flex mr-2 mt-2" paddingClass="px-1">
        <div className="flex justify-between items-center p-2 gap-3 flex-wrap">
          <h3 className="text-body-color text-xl font-semibold">
            Missing Authorization Form Patients({_this.tableData?.length})
          </h3>

          <Dropdown
            label={'Filter Type'}
            className="w-64 z-20 !mb-0"
            placeholder={'@select filter'}
            required
            type="text"
            options={[
              { label: 'Franchise', value: 'franchise' },
              { label: 'Location', value: 'location' }
            ]}
            value={_this.filterType}
            onChange={(e) => {
              _this.handleFilterTypeChange(e);
            }}
            aria-label="Franchise List"
          />
          <Dropdown
            label={`${
              _this.filterType?.value == 'franchise' ? 'Select Franchise' : 'Select Location'
            }`}
            className="w-64 z-20 !mb-0"
            placeholder={`${_this.filterType?.value == 'franchise' ? '@franchise' : '@location'}`}
            type="text"
            options={optionsList}
            required
            value={_this.selectedOption}
            onChange={(e) => {
              _this.setSelectedOption(e);
            }}
            aria-label="Franchise List"
          />

          {/* Search Input */}
          <input
            type="search"
            placeholder="Search.."
            value={_this.searchInput}
            onChange={(e) => _this.setSearchInput(e.target.value)}
            className="border rounded-md p-2 mt-3"
          />

          {/* Export Button */}
          <button
            onClick={exportReport}
            className="bg-blue-500 px-3 flex items-center justify-center text-white hover:bg-blue-600 mt-3"
            style={{ height: '42px' }}
          >
            Export
          </button>
        </div>
      </Card>

      <Card className="flex mr-2 mt-2" paddingClass="px-1">
        <Table
          keyField="_id"
          columns={columns}
          data={_this.tableData}
          headerComponent={null}
          minRows={20}
          SubComponent={({ original }) => (
            <div className="p-3 bg-gray-50 rounded-lg border my-2 text-center">
              <p className="font-semibold mb-2">
                <i>All The Documents of {original?.customer_name}</i>
              </p>
              {
                <ExpandedDocumentsTable
                  _this={{ ..._this, currentDocuments: original?.documents }}
                  documents={original?.documents}
                />
              }
            </div>
          )}
        />
      </Card>
    </div>
  );
};

export default Body;
